import { configureStore } from "@reduxjs/toolkit";

import reducer from "./reducer";

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these paths in the state
        ignoredPaths: ['slots.default', 'slots.express', 'slots.click_n_collect', 'slots.standard'],
        // Ignore these action paths (including meta.arg which contains slot data with Moment objects)
        ignoredActionPaths: ['payload', 'meta.arg', 'meta.arg.slotData'],
      },
    }),
});

export default store;
